import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tab, TabList, Divider } from "@fluentui/react-components";
import { HomeRegular, CalendarRegular, ClockRegular, PeopleRegular, PersonRegular, BookRegular, ChatHelpRegular, CalendarMonthRegular, PeopleTeamRegular, DataBarVerticalRegular, } from "@fluentui/react-icons";
const monEspace = [
    { key: "dashboard", label: "Tableau de bord", icon: _jsx(HomeRegular, {}) },
    { key: "absences", label: "Mes absences", icon: _jsx(CalendarRegular, {}) },
    { key: "badgeage", label: "Mes badgeages", icon: _jsx(ClockRegular, {}) },
    { key: "service", label: "Mon service", icon: _jsx(PeopleRegular, {}) },
    { key: "infos", label: "Mes informations", icon: _jsx(PersonRegular, {}) },
    { key: "parcours", label: "Mon parcours", icon: _jsx(BookRegular, {}) },
    { key: "aide", label: "Aide & contact", icon: _jsx(ChatHelpRegular, {}) },
];
const monEquipe = [
    { key: "equipe-dashboard", label: "Vue d'ensemble", icon: _jsx(DataBarVerticalRegular, {}) },
    { key: "equipe-planning", label: "Planning & Absences", icon: _jsx(CalendarMonthRegular, {}) },
    { key: "equipe-membres", label: "Membres", icon: _jsx(PeopleTeamRegular, {}) },
];
const groupLabelStyle = {
    padding: "12px 16px 4px",
    fontSize: "11px",
    fontWeight: 700,
    textTransform: "uppercase",
    color: "#666",
    letterSpacing: "0.5px",
};
export const ManagerSideNav = ({ activeView, onNavigate }) => (_jsxs("nav", { style: {
        width: "220px",
        minHeight: "100vh",
        borderRight: "1px solid var(--colorNeutralStroke1, #e0e0e0)",
        padding: "16px 0",
        backgroundColor: "#f0f4ff",
    }, "aria-label": "Espace responsable", children: [_jsx("div", { style: { padding: "0 16px 12px", fontWeight: 700, fontSize: "16px", color: "#0066cc" }, children: "Espace Responsable" }), _jsx("div", { style: groupLabelStyle, children: "Mon espace" }), _jsx(TabList, { vertical: true, selectedValue: activeView, onTabSelect: (_, data) => onNavigate(data.value), style: { width: "100%" }, children: monEspace.map((item) => (_jsx(Tab, { value: item.key, icon: item.icon, "data-tour": `nav-${item.key}`, children: item.label }, item.key))) }), _jsx(Divider, { style: { margin: "12px 0" } }), _jsx("div", { style: groupLabelStyle, children: "Mon \u00E9quipe" }), _jsx(TabList, { vertical: true, selectedValue: activeView, onTabSelect: (_, data) => onNavigate(data.value), style: { width: "100%" }, children: monEquipe.map((item) => (_jsx(Tab, { value: item.key, icon: item.icon, "data-tour": `nav-${item.key}`, children: item.label }, item.key))) })] }));
